import script from "./PriceList.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceList.vue?vue&type=script&setup=true&lang=js"

import "./PriceList.vue?vue&type=style&index=0&id=ab3122b8&lang=css"

const __exports__ = script;

export default __exports__